module.exports = __webpack_public_path__ + "static/media/21ECLAC48.4eb5be01.jpg";